import type { CanBuilder, DefineAbilityForUser } from "../types";
import { defineSojurRules } from "../attributions/sojur";
import { defineEticoRules } from "../attributions/etico";
import { defineEticiRules } from "../attributions/etici";
import { defineComitRules } from "../attributions/comit";

export function definePartnerRules({
	can,
	user,
}: {
	can: CanBuilder;
	user: DefineAbilityForUser;
}): void {
	can("read", "User");
	can("read", "Organization");
	can("read", "Application");
	can("read", "AIAQuestionnaire");
	can("read", "EPSQuestionnaire");

	if (user.attributions.includes("SOJUR")) defineSojurRules(can);
	if (user.attributions.includes("ETICO")) defineEticoRules(can);
	if (user.attributions.includes("ETICI")) defineEticiRules({ can, user });
	if (user.attributions.includes("COMIT")) defineComitRules(can);
}
